// extracted by mini-css-extract-plugin
export default {"error_page":"ErrorPage_error_page__pxCW5"};